__webpack_require__.p = "https://vogue.demosite.my/";